module.exports = __webpack_public_path__ + "static/kelioSearch-8f83799a6b92c5ae5b4b69476a3461d2.svg";